import styled from 'styled-components';
import Row from "../../kit/Row"

export const HomeWrapprr = styled(Row)`

 
`;